<script lang="ts" setup>
  import type { PropType } from 'vue';
  import type { Country } from '@storefront/types';
  import type { Dictionary, MedicalType, CustomerType } from '@othercommerce/domain';

  interface CustomerTypeDictionaryRecord {
    label: string;
    value: CustomerType;
  }

  interface MedicalTypeDictionaryRecord {
    label: string;
    value: MedicalType;
  }

  defineProps({
    countries: { type: Array as PropType<Country[]>, required: true },
    customerTypes: { type: Object as PropType<Dictionary<CustomerTypeDictionaryRecord>>, required: true },
    registerAgencies: { type: Object as PropType<Dictionary>, required: true },
    medicalPracticeGroups: { type: Object as PropType<Dictionary>, required: true },
    medicalTypes: { type: Object as PropType<Dictionary<MedicalTypeDictionaryRecord>>, required: true },
    regions: { type: Object as PropType<Dictionary>, required: true },
  });
</script>
<template>
  <main id="main" class="register">
    <SfTile large>
      <template #title>
        <h1 class="account-heading">
          {{ $t('SHOP.AUTH.HEADER.ALREADY_HAVE_ACCOUNT') }}
        </h1>
      </template>
      <SfButton :href="$route('web.account.session.create')">
        {{ $t('SHOP.AUTH.ACTION.SIGN_IN') }}
      </SfButton>
    </SfTile>
    <SfTile class="register__new-account" large>
      <template #title>
        <h2 class="account-heading">
          {{ $t('SHOP.AUTH.HEADER.SIGN_UP') }}
        </h2>
      </template>
      <AccountSignUpForm :countries :customerTypes :medicalPracticeGroups :medicalTypes :regions :registerAgencies />
    </SfTile>
  </main>

  <RouterView />
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  .register {
    display: grid;
    grid-template-columns: 2fr 3fr;
    justify-content: center;
    align-items: flex-start;
    gap: 4rem;
    max-width: 1200px;
    margin: 100px auto;
  }

  @include media.query(lg) {
    .register {
      grid-template-columns: 1fr;
      gap: 1rem;
      margin: 1rem 0 2rem;

      &__new-account {
        order: -1;
      }

      .tile__content {
        padding: 1.25rem 0.625rem;

        .tile__header {
          justify-content: center;
        }
      }
    }
  }
</style>
